import React, {useState} from "react";
import Footer from "../../components/Footer/FooterScreen";
import NavbarScreen from "../../components/NavBar/NavbarScreen";
import FormRegisterNormalScreen from "./components/FormRegisterNormalItem";
import FormRegisterSpecialScreen from "./components/FormRegisterSpecialItem";

import SupportScreen from "../../components/Support/SupportScreen";
import { Tabs } from "antd";

const { TabPane } = Tabs;
function RegisterNormalScreenV2(props) {


  const [checkActive, setCheckActive] = useState(false)
  const handleOnTapClick =(key, event) => {
    switch(key){
      case '1':
        setCheckActive(false)
        break;
      case '2':
        setCheckActive(true)
        break;
    }
  }
  return (
    <>
      <NavbarScreen />

      <div className="RegisterScreen container">
        <div className="row">
          <div className="content__left col-md-9 col-sm-12 p-0">
            <h1 className="content__title--one">Đằng kí tiêm chủng vắc xin</h1>
            <Tabs defaultActiveKey="1" onTabClick={handleOnTapClick}>
              <TabPane tab="ĐĂNG KÍ VẮC XIN THƯỜNG" key="1">
                <FormRegisterNormalScreen />
              </TabPane>
              <TabPane tab="ĐĂNG KÍ VẮC XIN ĐẶC BIỆT" key="2">
                <FormRegisterSpecialScreen checkActive={checkActive} />
              </TabPane>
            </Tabs>
          </div>
          <div className="content__right col-md-3 col-sm-12 pr-0">
            <SupportScreen />
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default RegisterNormalScreenV2;
